import MicroModal from 'micromodal';
import ready from '@ryanmorr/ready';

const options = {
  openTrigger: 'data-modal-open',
  closeTrigger: 'data-modal-close',
  openClass: 'm--open',
  disableScroll: true,
  disableFocus: false,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true,
  debugMode: false,
};

MicroModal.init({
  ...options,
});

window.emitter.on('modal:open', ({ id }) => {
  MicroModal.show(id, options);
});

window.emitter.on('modal:close', ({ id }) => {
  MicroModal.close(id);
});

(() => {
  ready('[data-modal-open]', (element) => {
    element.addEventListener('click', () => {
      MicroModal.show(element.dataset.modalOpen, options);
    });
  });
})();
